import BaseWrapper from "../../../components/ui/BaseWrapper";

export default function () {
  return (
    <div className="border-b border-zinc-300 bg-white">
      <BaseWrapper>
        <div className="py-[7px]">
          <h3 className="font-light">Permissions</h3>
        </div>
      </BaseWrapper>
    </div>
  );
}
